import React, { useState, useEffect, useMemo } from 'react'
import classNames from 'classnames'
import { useSwiper } from 'swiper/react'

interface IProps {
  cases: Array<{
    id: string | number
    [key: string]: any
  }>
  className?: string
}
const TabPagination: React.FC<IProps> = ({ cases, className }) => {
  const swiper = useSwiper()
  const [idx, setIdx] = useState(swiper.realIndex)

  useEffect(() => {
    const handler = (s: any) => {
      setIdx(s.realIndex)
    }
    swiper.on('realIndexChange', handler)
    return () => swiper.off('realIndexChange', handler)
  }, [])

  const active = useMemo(() => {
    return cases[swiper.realIndex]
  }, [idx])

  const handleClick = (acitve: (typeof cases)[number]) => {
    swiper.slideToLoop(cases.findIndex(it => it.id === acitve.id))
  }

  return (
    <div
      className={classNames(
        'w-full h-1 absolute left-0 bottom-6 flex justify-end z-[1000] pl-[88px] pr-[373px]',
        className
      )}
    >
      <div className="flex items-center gap-2">
        {cases.map(it => {
          return (
            <div
              key={it.id}
              className={classNames(
                'relative w-4 h-1 rounded-full bg-neutral-500 cursor-pointer bg-opacity-[0.16] before:absolute before:h-6 before:w-4 before:-top-2',
                {
                  'bg-neutral-500 bg-opacity-[1]': active === it,
                }
              )}
              onClick={() => {
                handleClick(it)
              }}
            ></div>
          )
        })}
      </div>
    </div>
  )
}
export default TabPagination
